import { useEffect, useState } from "react";
import {
  IonContent,
  IonHeader,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonButton,
} from "@ionic/react";
import ScanModal from "../../Modals/ScanModal/ScanModal";
import TickTitleBar from "../../components/TickTitleBar/TickTitleBar";
import { useHistory } from "react-router-dom";
import styles from "./Education.module.scss";
import { useTranslation } from "react-i18next";
import TickSelect from "../../components/TickSelect/TickSelect";
import TickSelectWithSearch from "../../components/TickSelectWithSearch/TickSelectWithSearch";
import { deCrypt, handleSelectAttendInfo } from "../../helpers/helpers";

const Education = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const [educationCourseType, setEducationCourseType] = useState(null);
  const [educationClass, setEducationClass] = useState(null);

  const [isAttendanceModalVisible, setIsAttendanceModalVisible] =
    useState(false);
  const [isDepartureModalVisible, setIsDepartureModalVisible] = useState(false);

  useEffect(() => {
    deCryptStorage();
  }, []);

  const handleRefresh = (event) => {
    setTimeout(() => {
      clearState();
      event.detail.complete();
    }, 2000);
  };

  const handleAttendanceModalVisible = () => {
    setIsAttendanceModalVisible(!isAttendanceModalVisible);
  };

  const handleDepartureModalVisible = () => {
    setIsDepartureModalVisible(!isDepartureModalVisible);
  };

  const clearState = () => {
    setEducationCourseType(null);
    setEducationClass(null);
  };

  const handleEducationCourseType = (data) => {
    setEducationCourseType(data);
    handleSelectAttendInfo("educationCourseType", data);
  };

  const handleEducationClass = (data) => {
    setEducationClass(data);
    handleSelectAttendInfo("educationClass", data);
  };

  const deCryptStorage = () => {
    const educationRecord = deCrypt(localStorage.getItem("selectAttendInfo"));
    setEducationCourseType(parseInt(educationRecord["educationCourseType"]));
    setEducationClass(parseInt(educationRecord["educationClass"]));
  };

  return (
    <>
      <IonPage id="main-content">
        <IonHeader>
          <TickTitleBar
            title="t_education"
            onGoBack={() => history.push("/masAttendance/main")}
            rightBtnContent={educationClass && "t_record"}
            onRightClick={() =>
              history.push(
                `/masAttendance/record?category=education&id=${educationClass}`
              )
            }
          />
        </IonHeader>
        <IonContent className={styles.homeBg}>
          <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
            <IonRefresherContent />
          </IonRefresher>
          <div className={styles.mainContainer}>
            <div className={styles.upperWrapper}>
              <div>
                <TickSelectWithSearch
                  type="educationClass"
                  setFirstField={setEducationCourseType}
                  setSecondField={setEducationClass}
                  showId
                />
                <TickSelect
                  label={"t_educationCourseType"}
                  setDetail={handleEducationCourseType}
                  detail={educationCourseType}
                  type="educationCourseType"
                />
                <TickSelect
                  label={"t_educationClass"}
                  setDetail={handleEducationClass}
                  detail={educationClass}
                  type="educationClass"
                  params={educationCourseType}
                  showId
                  disabled={!educationCourseType}
                />
              </div>
              <IonButton
                expand="block"
                className="manual"
                disabled={educationClass ? false : true}
                onClick={() =>
                  history.push(
                    `/masAttendance/manualAttendance?category=education&id=${educationClass}`
                  )
                }
              >
                {t("t_manual")}
              </IonButton>
            </div>
            <div className={styles.bottomWrapper}>
              <IonButton
                expand="block"
                className="attendance"
                disabled={educationClass ? false : true}
                onClick={handleAttendanceModalVisible}
              >
                {t("t_attendance")}
              </IonButton>
              <IonButton
                expand="block"
                className="departure"
                onClick={handleDepartureModalVisible}
              >
                {t("t_departure")}
              </IonButton>
            </div>
          </div>
        </IonContent>
      </IonPage>
      {isAttendanceModalVisible ? (
        <ScanModal
          visible={isAttendanceModalVisible}
          setVisible={setIsAttendanceModalVisible}
          clearState={clearState}
          isAttendance
          id={educationClass}
          type={"education"}
          details={[educationCourseType, educationClass]}
        />
      ) : null}
      {isDepartureModalVisible ? (
        <ScanModal
          visible={isDepartureModalVisible}
          setVisible={setIsDepartureModalVisible}
          clearState={clearState}
          id={educationClass}
          type={"education"}
        />
      ) : null}
    </>
  );
};

export default Education;
